import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { User, UserService } from 'taxtank-core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class ClientGuard {
  constructor(private userService: UserService, private router: Router) { }

  canActivate(): Observable<boolean> {
    // fetch because user can be changed while trying to access client area (post trial)
    return this.userService.getFirst().pipe(map(user => this.check(user)));
  }

  check(user: User): boolean {
    if (user.isEmployee()) {
      this.router.navigateByUrl('/firm');
    }

    return true;
  }
}
